import { createFileRoute } from '@tanstack/react-router'
import {
  Navbar,
  Footer,
  Hero,
  ProblemSolution,
  FeatureGrid,
  TokensSection,
  HowItWorks,
  ComponentsPreview,
  Credibility,
  FinalCTA,
} from '@/components/garmisch'

export const Route = createFileRoute('/_public/')({
  component: HomePage,
})

function HomePage() {
  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0B]">
      <Navbar />
      <main>
        <Hero />
        <ProblemSolution />
        <FeatureGrid />
        <TokensSection />
        <HowItWorks />
        <ComponentsPreview />
        <Credibility />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  )
}
